import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The house size scale (src/styles/app.css, documented in src/styles/CLAUDE.md).
 * tailwind-merge only knows Tailwind's stock names, so `text-11` reads to it as
 * a text COLOUR and `cn('text-11 text-text-2', 'text-term-dim')` silently drops
 * the size. Teaching it the two custom namespaces is what keeps a caller's
 * colour override from eating the font size.
 */
const FONT_SIZE_STEPS = ['9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '22', '26', '30', '34', '40', '46'];
const RADIUS_STEPS = ['2', '4', '6', '8', '10', '12', '14', '16', '20', '24', '32'];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZE_STEPS }],
      rounded: [{ rounded: RADIUS_STEPS }],
    },
  },
});

/** Merge conditional class names and de-conflict Tailwind utilities. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
